/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 查询该项目是否被我设置开票提醒和是否被我收藏
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  productId: string,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: member.ProductInfoDTO;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/product/${productId}/exist`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
